module.exports = "<div class=\"buttons-group\">\r\n\t<button class=\"add-case\" type=\"button\" (click)=\"showEditCaseModal()\">\r\n\t\tAdd Case\r\n\t</button>\r\n\t<button class=\"save-case\" type=\"button\" (click)=\"showSaveCaseModal()\">\r\n\t\tSave As\r\n\t</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases-tools/cases-tools.component.html
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases-tools/cases-tools.component.html
// module chunks = main